import { GsmGraph } from '@ui/graph/variants/gsm-graph'
import { BusyPeriodsGraph } from '@ui/graph/variants/three-colors-graph'
import { type ChartOptions } from 'chart.js'
import { Bar, Pie } from 'react-chartjs-2'

import { ContentfulGraphTemplate, type Value } from './graph-types'

export const DEFAULT_GRAPH_OPTIONS: ChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      fullSize: true,
      position: 'bottom',
    },
    tooltips: {
      enabled: true,
    },
  },
}

export const mergeOptions = (
  defaultOptions: ChartOptions,
  additionalOptions: ChartOptions
): ChartOptions => {
  const result = { ...defaultOptions }

  for (const [key, value] of Object.entries(additionalOptions)) {
    if (
      Object.hasOwn(result, key) &&
      typeof value === 'object' &&
      typeof result[key] === 'object'
    ) {
      result[key] = mergeOptions(result[key], value)
    } else {
      result[key] = value
    }
  }

  return result
}

export const generateDatasetFromValues = (
  values: readonly Value[],
  keyOverwrite = 'value'
) => {
  const labels: string[] = []
  const data: number[] = []
  const colors: string[] = []
  values.forEach((value) => {
    labels.push(value.title)
    data.push(value[keyOverwrite])
    colors.push(value.color || null)
  })
  return {
    labels: labels,
    colors,
    data,
  }
}

export const GraphComponentMapper = {
  [ContentfulGraphTemplate.Bar]: Bar,
  [ContentfulGraphTemplate.Pie]: Pie,
  [ContentfulGraphTemplate.BusyPeriods]: BusyPeriodsGraph,
  [ContentfulGraphTemplate.Gsm]: GsmGraph,
  [ContentfulGraphTemplate.Gsm_Bourse]: GsmGraph,
  default: GsmGraph,
}
